import React, { useRef } from 'react';
import styles from './ModalCover.module.css';
import { useModalSystem } from 'config/context/ModalSystemContext';
import useTheme from 'config/useTheme';

const ModalCover = ({ children, closeOnOverlay, size='md' }) => {
    const modalCoverRef = useRef(null);
    const { dark } = useTheme();
    const { hideModal } = useModalSystem();

    const sizeClasses = {
        sm: styles.small,
        md: styles.medium,
        lg: styles.large,
        xlg: styles.xlarge
    };

    const handleOutsideClick = (e) => {
        if (!modalCoverRef.current.contains(e.target) && closeOnOverlay) {
            hideModal();
        }
    };
    
    return (
        <div onClick={handleOutsideClick} className={`${styles.component} ${dark ? styles.dark : ""}`}>
            <div 
                ref={modalCoverRef} 
                onClick={(e) => e.stopPropagation()} 
                className={`${styles.modal_cover} ${sizeClasses[size] || sizeClasses.md}`}
            >
                {children}
            </div>
        </div>
    );
}

export default ModalCover;